import { combineReducers } from "redux";
import { loggerReducer } from "../coraWebComponents/utils/logger";

// user
import user from "./user";
import oAuthUser from "./oAuthUser";
import verifications from "./verifications";

// files
import files from "./files";
import reports from "./reports/reports";

// app header
import header from "./header/header";

// spravy
import countNeprecitaneSpravy from "./spravy/countNeprecitaneSpravy";
import sprava from "./spravy/sprava";
import listSprava from "./spravy/listSprava";

// ziadost
import ziadost from "./ziadost/ziadost";
import myListZiadost from "./ziadost/myListZiadost";
import allListZiadost from "./ziadost/allListZiadost";

// vyjadrenie
import vyjadrenie from "./vyjadrenie/vyjadrenie";
import listVyjadrenie from "./vyjadrenie/listVyjadrenie";

// uloha
import uloha from "./uloha/uloha";
import listUloha from "./uloha/listUloha";

// mapa
import mapa from "./mapa/mapa";

// tables
import aaDefOB from "./tables/aaDefOB";

// ciselniky
import zpCDovod from "./ciselniky/zpCDovod";
import zpCPriorita from "./ciselniky/zpCPriorita";
import zpCTypPrace from "./ciselniky/zpCTypPrace";
import zpCStavZiadosti from "./ciselniky/zpCStavZiadosti";
import zpCVysledokVyjadrenia from "./ciselniky/zpCVysledokVyjadrenia";



const rootReducer = combineReducers({
  loggerReducer,

  // files
  files,

  // reports
  reports,

  // user
  user,
  oAuthUser,
  verifications,

  // app header
  header,

  // spravy
  countNeprecitaneSpravy,
  sprava,
  listSprava,

  // vyjadrenie
  vyjadrenie,
  listVyjadrenie,

  // uloha
  uloha,
  listUloha,

  // ziadost
  ziadost,
  myListZiadost,
  allListZiadost,

  // mapa,
  mapa,

  // tables
  aaDefOB,

  // ciselniky
  zpCDovod,
  zpCPriorita,
  zpCTypPrace,
  zpCStavZiadosti,
  zpCVysledokVyjadrenia,
});

export default rootReducer;
